var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRankingArrowDown({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 10,
    viewBox: "0 0 16 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.45759 9.03557C8.06707 9.42609 7.43391 9.42609 7.04338 9.03557L0.709335 2.70152C0.0790654 2.07125 0.526001 0.993622 1.41734 0.994419L14.0741 1.00573C14.9646 1.00652 15.41 2.08317 14.7803 2.71283L8.45759 9.03557Z",
    fill: "#E80E36"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRankingArrowDown);
export default __webpack_public_path__ + "static/media/ranking-arrow-down.e71a0ca3d5cccf14e0d6e19a54ea38d3.svg";
export { ForwardRef as ReactComponent };